enum VehicleUses {
  COMPETENCIAS = 14,
  'ESCUELA DE APRENDIZAJES' = 12,
  MILITAR = 17,
  MUNICIPAL = 18,
  'PERSONAL/PRIVADO' = 1,
  'SERVICIOS A DOMICILIO' = 26,
  TAXI = 19,
  'TAXI TURISTICO' = 20,
  VENDEDOR = 16,
}

export default VehicleUses;
